const csvParse = (data: string, delimiter = ','): string[][] => {
    /* //uncomment below if we want to include titles
    const titles = data.slice(0, data.indexOf('\n')).split(delimiter);
    */
    return data
        .slice(data.indexOf('\n') + 1)
        .split('\n')
        .map(v => {
            return v.split(delimiter);
            /* //uncomment below if want to turn into JSON with titles
            // const values = v.split(delimiter);
            // return titles.reduce((obj, title, index) => ((obj[title] = values[index]), obj), {});
            */
        });
};

export default csvParse;
